export const isSet = <T>(v: T, falsyToTrue = false): v is NonNullable<T> => {
  const value: unknown =
    falsyToTrue && (v === 0 || v === false) ? String(v) : v;

  return (
    value !== undefined && value !== null && value !== '' && value !== 'null'
  );
};
